import { useParams } from 'next/navigation';
import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import GuestPass from '@/components/guestPass';
import Layout from '@/components/layout/LayoutWrapper';
import AuthModalContextProvider from '@/context/AuthModalContextProvider';
import { useGuestPass } from '@/hooks/guestPass/useGuestPass';
import messages from '@/messages/messages';
import getUrl from '@/utils/getUrl';

const GpGuestPass = () => {
	const params = useParams();
	const code = typeof params?.code === 'string' ? params.code : undefined;
	const { formatMessage } = useIntl();
	const { data, error, loading } = useGuestPass(code);

	return (
		<Layout
			pageName="gp"
			customSeo={{
				title: formatMessage(messages.guestPassPageTitle),
				imageUrl: `${getUrl('www')}/_n/images/guest-pass/asset-guest-pass.png`,
			}}
			title="Calm - Redeem Guest Pass"
		>
			<AuthModalContextProvider>
				<GuestPass
					loading={loading}
					canRedeem={data?.valid || false}
					code={code}
					error={error}
					sender={data?.sender_name || ''}
					trialLength={data?.trial_length || 30}
				/>
			</AuthModalContextProvider>
			<Footer />
		</Layout>
	);
};

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';

export default GpGuestPass;
